import { FC, useContext, useState } from 'react';

import { LikedRecommendIc } from '../../../../assets/icons/svgIconsForJSX';
import { classNameBuilder } from '../../../../utils/className';

import { ModalViewContext } from '../../../../context/modalView/ModalViewContext';
import { IVacancyDto } from '../../../../models/Vacancy/IVacancyDto';
import { vacancyFavoriteService } from '../../../../services/vacancyFavoriteService';
import { utils } from '../../../../utils/Utils';
import { ModalContentView } from '../../../Modal/ModalContentView/ModalContentView';
import { AuthContext } from '../../../auth/AuthContext';
import './Vacancy.scss';

interface IProps {
    link: string;
    isFavorite?: boolean;
    changeFavorite?: (vacancy: IVacancyDto) => void;
    vacancy: IVacancyDto;
    dictionaries: { [key: string]: string };
}

const Vacancy: FC<IProps> = ({ link, isFavorite, changeFavorite, vacancy, dictionaries }) => {
    const cn = classNameBuilder('vacancy');

    const [favoriteState, setFavoriteState] = useState<boolean | undefined>(isFavorite);

    const { openModal } = useContext(ModalViewContext);
    const { user } = useContext(AuthContext);

    const clickFavorite = () => {
        vacancyFavoriteService
            .updateVacancyFavorite({
                vacancyId: vacancy.id,
                isFavorite: !favoriteState,
            })
            .then(() => setFavoriteState(!favoriteState))
            .catch((err) => {
                // console.log(err)
            });
        setFavoriteState(!favoriteState);
        changeFavorite && changeFavorite(vacancy);
    };

    const isYouthProject = vacancy.jobType === 'DEVELOPMENT' || vacancy.jobType === 'SCHOLARSHIP';

    return (
        <div className={cn()}>
            <a href={isYouthProject ? '/scholarship' : link} className={cn('link')} />
            <div className={cn('head')}>
                <p className={cn('category')}>{dictionaries[vacancy?.jobDirectionType]}</p>
            </div>
            <h3 className={cn('title', { internship: vacancy.jobType !== 'POINT' })}>
                {vacancy.name}
            </h3>
            <div className={cn('foot')}>
                <p className={cn('city')}>{isYouthProject ? '' : vacancy.potokAreaName}</p>
                <button
                    type="button"
                    className={cn('favorite')}
                    onClick={() => {
                        if (user) {
                            clickFavorite();
                        } else {
                            openModal({
                                className: cn('vacancy-favorite'),
                                position: 'center',
                                closeBtn: {
                                    isButton: true,
                                },
                                isBackground: true,
                                children: (
                                    <ModalContentView
                                        title={'Вход'}
                                        typeTitle={'h1'}
                                        text={'Пожалуйста, войдите в свою учетную запись'}
                                        btnPosition={'space-between'}
                                        button={[
                                            {
                                                theme: 'light',
                                                name: 'Зарегистрироваться',
                                                border: true,
                                                onAction: () => utils.Redirect('/register'),
                                            },
                                            {
                                                theme: 'dark',
                                                name: 'Войти',
                                                onAction: () => {
                                                    utils.Redirect('/login?is_back=true');
                                                },
                                            },
                                        ]}
                                    />
                                ),
                            });
                        }
                    }}>
                    {favoriteState ? (
                        <LikedRecommendIc onRecommend={favoriteState && Boolean(user)} />
                    ) : (
                        <LikedRecommendIc onRecommend={favoriteState && !user} />
                    )}
                </button>
            </div>
            {vacancy.jobType === 'INTERNSHIP' && <p className={cn('internship')}>Стажировка</p>}
            {isYouthProject && <p className={cn('internship')}>Молодежный проект</p>}
        </div>
    );
};

export default Vacancy;
